"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
exports.theme = {
    container: {
        box: 'min-h-full flex flex-col flex-1',
        colors: '',
        font: '',
    },
    main: {
        box: 'flex-1 py-6',
        colors: '',
        font: '',
    },
};
//# sourceMappingURL=themes.js.map